export default Object.freeze({
    MOST_SUCCESSFUL_ROUTE: 'MOST_SUCCESSFUL_ROUTE',
    LEAST_SUCCESSFUL_ROUTE: 'LEAST_SUCCESSFUL_ROUTE',
    MOST_TAKEN_ROUTE: 'MOST_TAKEN_NODE',
    LEAST_TAKEN_ROUTE: 'LEAST_TAKEN_NODE'
});